import { z } from 'zod'

const goalDimensionSchema = z.object({
  id: z.string(),
  label: z.string(),
  selectOptions: z.string().array(),
})

export const goalAggregationFunctionEnum = z.enum([`sum`, `avg`])
export const kpiArchivementStatusTargetValueTypeEnum = z.enum([`averageProgress`, `goal`, `zero`])
const goalConfigKpiViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  aggregationFunction: goalAggregationFunctionEnum,
  achievementStatusTargetValueType: kpiArchivementStatusTargetValueTypeEnum.nullable().optional(),
})
export type GoalConfigKpiView = z.infer<typeof goalConfigKpiViewSchema>

// UI側のフォームでも使っているので注意(むしろ分けた方が良いだろうか？)
export const goalConfigSchema = z.object({
  id: z.string(),
  name: z.string(),
  timeSpanType: z.enum(['month', 'week', 'day', 'none']),
  userType: z.enum(['user', 'group', 'none']),
  goalDimension1: goalDimensionSchema.nullish(),
  goalDimension2: goalDimensionSchema.nullish(),
  goalDimension3: goalDimensionSchema.nullish(),
  goalDimension4: goalDimensionSchema.nullish(),
  goalDimension5: goalDimensionSchema.nullish(),
  kpiViews: goalConfigKpiViewSchema.array(),
  commitmentKpiLabel: z
    .object({
      viewId: z.string(),
      startAt: z.string(),
      endAt: z.string(),
    })
    .nullable()
    .optional(),
})
export type GoalConfig = z.infer<typeof goalConfigSchema>
